module.exports = __webpack_public_path__ + "img/meetsanta2.519709f1.jpg";